import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import styles from "./../icon.css";
var IconTv = function (_a) {
    var customStyle = _a.customStyle;
    return (_jsxs("svg", { viewBox: "0 0 30 24", className: classNames(customStyle, styles.stroke), children: [_jsx("defs", { children: _jsx("path", { id: "a", d: "M0 0h30v24H0z" }) }), _jsxs("g", { fill: "none", fillRule: "evenodd", children: [_jsx("path", { d: "M29.5 16.5c0 1.1-.9 2-2 2h-25c-1.1 0-2-.9-2-2v-14c0-1.1.9-2 2-2h25c1.1 0 2 .9 2 2v14z" }), _jsx("path", { d: "M27.5 16.5h-25v-14h25zm-14 2v3m3-3v3" }), _jsx("path", { d: "M24.515 23.5c-2.498-1.24-5.84-2-9.515-2-3.674 0-7.016.76-9.514 2", strokeLinecap: "round", strokeLinejoin: "round" })] })] }));
};
export default IconTv;
